export default [
  { value: 'NONE', label: 'None' },
  { value: 'CRAWL_SPACE', label: 'Crawl Space' },
  { value: 'PARTIAL', label: 'Partial' },
  { value: 'FULL', label: 'Full' },
];
